// One flag for the device, not per map: a master showing their screen wants every map clean.
const KEY = "map-notes-hidden";

export function notesHiddenStored() {
	try {
		return localStorage.getItem(KEY) === "1";
	} catch {
		return false;
	}
}

export function storeNotesHidden(on: boolean) {
	try {
		if (on) localStorage.setItem(KEY, "1");
		else localStorage.removeItem(KEY);
	} catch {
		// A private window or blocked storage only loses the choice.
	}
}
